import { Flex, Text } from "@chakra-ui/react";
import { IconCheckWhite } from "icons";

const JoinedLeaderboardTag = () => {
  return (
      <Flex
        background="linear-gradient(90.65deg, rgba(0, 255, 232, 0.4) 0.56%, rgba(0, 255, 232, 0) 99.44%)"
        borderRadius="4px"
        position="relative"
        _before={{
          content: '""',
          position: "absolute",
          inset: 0,
          borderRadius: "4px",
          borderRightRadius: "0px",
          padding: "2px",
          paddingRight: "0px",
          background: "linear-gradient(90.65deg, rgba(0, 255, 232, 0.4) 0.56%, rgba(0, 255, 232, 0) 99.44%)",
          mask: "linear-gradient(#000 0 0) content-box, linear-gradient(#000 0 0)",
          maskComposite: "exclude",
        }}
        borderRight="none"
        gap="1"
        shadow="0px 2px 6px 2px rgba(0, 0, 0, 0.15)"
        alignItems="center"
        px="8px"
        pr="12px"
        py="8px"
      >
        <IconCheckWhite 
          __css={{
            path: {
              fill: "rgba(0, 255, 232, 1)"
            }
          }}
          boxSize={4}
        />

        <Text
          fontSize="14px"
          lineHeight="18px"
          fontWeight="600"
          color="rgba(0, 255, 232, 1)"
        >
          LEADERBOARD
        </Text>
      </Flex>
  );
};

export default JoinedLeaderboardTag;